import React from 'react';
import collapseIcon from './assets/collapse-icon.png';
import expandIcon from './assets/expand-icon.png';

const ExpandButton = ({ onClick, expanded }) => {
  const expandButton = {
    backgroundColor: '#489EA3',
    border: 'none',
    color: 'white',
    margin: '12px 0 4px 0',
    float: 'right',
    padding: '6px 12px',
    width: '120px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '14px',
  };

  const iconStyle = {
    height: '16px',
    width: '16px',
    objectFit: 'contain',
  };

  return (
    <button
      style={expandButton}
      onClick={onClick}
      aria-expanded={expanded}
      type="button"
      title={expanded ? 'Collapse match details' : 'Expand match details'}
    >
      <img
        src={expanded ? collapseIcon : expandIcon}
        alt={expanded ? 'Collapse' : 'Expand'}
        style={iconStyle}
      />
      {expanded ? 'COLLAPSE' : 'EXPAND'}
    </button>
  );
};

export default ExpandButton;
